import { render, staticRenderFns } from "./recipes.vue?vue&type=template&id=f3240034&scoped=true&"
import script from "./recipes.vue?vue&type=script&lang=js&"
export * from "./recipes.vue?vue&type=script&lang=js&"
import style0 from "./recipes.vue?vue&type=style&index=0&id=f3240034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3240034",
  null
  
)

export default component.exports